const actions = {
  CONFIG_DATA_BEGIN: 'CONFIG_DATA_BEGIN',
  CONFIG_DATA_SUCCESS: 'CONFIG_DATA_SUCCESS',
  CONFIG_DATA_ERR: 'CONFIG_DATA_ERR',

  getDataBegin: () => {
    return {
      type: actions.CONFIG_DATA_BEGIN,
    };
  },

  getDataSuccess: data => {
    return {
      type: actions.CONFIG_DATA_SUCCESS,
      data,
    };
  },

  getDataErr: err => {
    return {
      type: actions.CONFIG_DATA_ERR,
      err,
    };
  },
};

export default actions;
